module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mailHolder bg-color-6 lightest d-flex justify-content-center",
    class: {
      'closed': _vm.isClosed
    }
  }, [_c('i', {
    staticClass: "closeIcon pointer fas fa-times-circle",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerHolder py-3"
  }, [_c('span', [_vm._v("For the best experience please use a modern web browser like Microsoft Edge, "), _c('a', {
    staticClass: "underlined",
    attrs: {
      "href": "https://www.google.com/chrome/",
      "target": "_blank"
    }
  }, [_vm._v("Google Chrome")]), _vm._v(" or "), _c('a', {
    staticClass: "underlined",
    attrs: {
      "href": "https://www.mozilla.org/firefox/",
      "target": "_blank"
    }
  }, [_vm._v("Firefox")]), _vm._v(".")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4ea512f9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ea512f9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/other/noInternetExplorer.vue
// module id = 1466
// module chunks = 0